import QueryBase from './QueryBase';
import log from 'loglevel';
/**
 *
 *
 * @export
 * @class CompatBoardSeek
 * @extends {QueryBase}
 */
export default class CompatBoardSeek extends QueryBase {
  constructor() {
    super();
  }

  query(start, end) {
    let data = this.dbController.dbData;
    let result = Array.prototype.slice.call(data).filter((item, index) => {
      return item.time < end && item.cid === this.cid;
    });

    log.info(`起始时间:${start}, 终止时间:${end}, 找到了${result.length}条数据`);
    return result;
  }
}
